<template>
  <div class="news-showcase">
  <div class="container news-shell">
    <section class="articles-showcase">
      <div class="section-header">
        <div>
          <h2 class="news-section-title">{{ $t('menuBerita.submenu1') }}</h2>
          <div class="section-header-line"></div>
        </div>
      </div>
    <div class="row article-grid justify-content-center">
      <div class="col-xl-3 col-md-6 col-12 mb-4 article-col">
              <button
                type="button"
                class="card article-card"
                data-bs-toggle="modal"
                data-bs-target="#art1"
              >
                <div class="article-media">
                  <img src="@/assets/artikel/MOUPIMDANPIU1.jpg" class="article-image" />
                  <span class="article-badge">2025</span>
                </div>
                <div class="card-body article-card-body text-start">
                  <div class="article-card-content">
                    <h5 class="article-card-title">
                      Penandatanganan nota kesepahaman Pupuk Indonesia Utilitas (MoU) dengan Pupuk Iskandar Muda
                    </h5>
                    <div class="card-read-more">
                      <span>{{ $t('menuBerita.readMore') }}</span>
                      <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
                    </div>
                  </div>
                </div>
              </button>
            </div>

            <!-- Modal -->

            <div class="modal fade" id="art1" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                       Penandatanganan nota kesepahaman Pupuk Indonesia Utilitas (MoU) dengan Pupuk Iskandar Muda
                    </h2>
                    <!-- <div class="row">
                                                <div class="col-md-6 mb-3"> -->
                    <img
                      src="@/assets/artikel/MOUPIMDANPIU1.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >2025</small
                      >
                    </p>
                    <!-- </div>
                                                <div class="col-md-6"> -->
                  
                     <p class="text-justify">
                    PT Pupuk Iskandar Muda (PIM) resmi menjalin kerja sama dengan PT Pupuk Indonesia Utilitas (PI Utilitas) melalui
                    penandatanganan Nota Kesepahaman (MoU) pada Selasa, 17 Desember 2024 di Kantor Pusat PT Pupuk Iskandar Muda di
                    Krueng Geukuh, Aceh Utara. Penandatanganan nota kesepahaman yang dilakukan oleh Direktur Utama PI Utilitas Mochamad
                    Safiie dan Direktur Utama PT Pupuk Iskandar Muda Budi Santoso Syarif. Kedua perusahaan akan mengembangkan solusi
                    inovatif seperti PLTS untuk perumahan dan fasilitas umum, pengelolaan WTP & WWTP, pengembangan nitrogen, hingga
                    penyediaan utilitas untuk mendukung Green Amonia. Acara ini menjadi momen penting dalam upaya bersama untuk
                    mendukung efisiensi dan keberlanjutan operasional perusahaan. MoU ini bertujuan untuk menggali potensi penyediaan
                    dan pengelolaan utilitas seperti listrik, air, dan steam yang diperlukan untuk mendukung operasional Pupuk Iskandar Muda.
                    <br>
                    <br>
                    Kerjasama ini sekaligus mencerminkan sinergi positif antara entitas di bawah Pupuk Indonesia Group, yang berkomitmen
                    mewujudkan daya saing perusahaan yang lebih kuat dan kinerja unggul. Budi Santoso Syarif menyampaikan bahwa langkah
                    ini bukan sekadar penandatanganan simbolis, melainkan awal dari perjalanan strategis bersama. Kolaborasi ini diharapkan
                    tidak hanya menjadi solusi atas kebutuhan utilitas perusahaan, tetapi juga melahirkan inovasi-inovasi baru yang lebih
                    efisien, ramah lingkungan, dan sesuai dengan standar operasional terbaik.
                    <br>
                    <br>
                    Kerja sama ini merupakan wujud nyata dari semangat sinergi yang akan memperkuat peran Pupuk Iskandar Muda dalam memenuhi
                    kebutuhan sektor pertanian nasional dan mendukung ketahanan pangan Indonesia. Lebih dari itu, langkah ini juga mendukung
                    program kemandirian energi dan menciptakan nilai tambah bagi Pupuk Indonesia Group secara keseluruhan dan mendorong transisi
                    menuju energi hijau. Dari Aceh Utara, kerja sama ini menjadi awal perjalanan untuk keberlanjutan dan pertumbuhan bisnis
                    yang lebih besar.
                    </p>

                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- end of modal -->

            <div class="col-xl-3 col-md-6 col-12 mb-4 article-col">
              <button
                type="button"
                class="card article-card"
                data-bs-toggle="modal"
                data-bs-target="#art2"
              >
                <div class="article-media">
                  <img src="@/assets/artikel/COTRADINGOVER1.jpg" class="article-image" />
                  <span class="article-badge">2025</span>
                </div>
                <div class="card-body article-card-body text-start">
                  <div class="article-card-content">
                    <h5 class="article-card-title">
                       Komersialisasi dan sinergi perdana gas karbon monoksida (CO) treated
                    </h5>
                    <div class="card-read-more">
                      <span>{{ $t('menuBerita.readMore') }}</span>
                      <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
                    </div>
                  </div>
                </div>
              </button>
            </div>

            <!-- Modal -->

            <div class="modal fade" id="art2" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      Komersialisasi dan sinergi perdana gas karbon monoksida (CO) treated
                    </h2>
                    <!-- <div class="row">
                                                <div class="col-md-6 mb-3"> -->
                    <img
                      src="@/assets/artikel/COTRADINGOVER1.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >2025</small
                      >
                    </p>
                    <!-- </div>
                                                <div class="col-md-6"> -->
                    <p class="text-justify">
                      <b>Gambaran umum Gas Karbon monoksida.</b><br>
                  Gas karbon monoksida (CO) merupakan Gas sintentis dari yang dihasilkan dari pembakaran bahan bakar yang mengandung karbon seperti gas alam dan bensin. 
                  Gas buangan yang berupa gas CO (karbon monoksida) dapat dimanfaatkan kembali untuk dijual kepada industri yang membutuhkan seperti industri besi baja, industri yang membuat dry ice dan juga sebagai energi/ bahan bakar untuk pengelasan.
                    </p>
                    <p class="text-justify">
                      <b>Gambaran umum Gas Karbon monoksida di Indonesia.</b><br>
                Saat ini di Indonesia hanya terdapat satu Pabrik yang menjalankan proses pemurnian Gas CO yaitu PT Pupuk Kujang Cikampek melalui anak perushaannya, 
                PT Sintas Kurama Perdana (SKP). Gas CO yang dimurnikan didapatkan dari proses pembuatan amonia pada Pabrik Kujang 1A yang kemudian Gas CO tersebut dikirimkan ke unit Pabrik Pemurnian CO (PPCO), 
                setelah dimurnikan Gas CO tersebut dialirkan menuju PT SKP untuk menjadi salah satu bahan baku dalam memproduksi asam formiat. Sampai saat ini kebutuhan Gas CO oleh industri masih disupport dari luar negeri.
                 Tentunya hal ini bisa menjadi peluang bisnis baru bagi industri Gas dan Utilitas.
                    </p>
                    <p class="text-justify">
                      <b>Proses produksi (umum) gas CO</b><br>
                 Gas CO digunakan sebesar 1%-3% yang didapatkan dari secondary reformer proses pembuatan ammonia di Pabrik Kujang 1A. Kemudian gas
                  CO disalurkan menuju unit Pabrik Pemurnian CO (PPCO) untuk ditingkatkan konsentrasinya menggunakan teknologi cosorb (CO Absorbtion)
                   menjadi diatas 98% yabng kemudian disalurkan kepada PT SKP sebagai bahan baku pembuatan asam formiat.
                      </p>
                      <p class="text-justify">
                        <b>Potensi Bisnis gas CO</b><br>
                      Saat ini Pabrik Pemurnian CO (PPCO) di Indonesia hanya dimiliki oleh PT Pupuk Kujang Cikampek dengan kapasitas 12-13 Ton per hari.
                       Hal ini tentunya dapat menjadi potensi bisnis yang baik bagi industri yang membutuhkan Gas CO di area Jawa Barat sampai dengan banten.
                        Dalam hal ini peluang bisnis yang bisa didapat oleh PI Utilitas adalah dengan menjadi Trader utama Gas CO.
                      </p>
                      <p class="text-justify">
                        <b>Skema Perdagangan Kredit Karbon monoksida</b><br>
                         Dikenal juga dengan sistem baseline-and-crediting atau carbon offset. Skema ini tidak membutuhkan kuota (allowances) di awal periode, 
                       karena yang dijadikan sebagai komoditi (disebut sebagai kredit karbon) adalah hasil sertifikasi penurunan emisi karbon akibat pelaksanaan
                      </p>
                       <p class="text-justify">
                      Pada skema kredit karbon, nilai kredit didapatkan di akhir suatu periode (ex-post) yang dapat dijual dan digunakan oleh peserta
                      untuk memenuhi target penurunan emisi atau menjadikan posisi peserta menjadi carbon neutral atau zero emission.
                      </p>
                      <p class="text-justify">
                         Sedangkan untuk skema ETS, nilai kredit sudah ditentukan di awal (ex-ante), sehingga kredit baru dapat diperjualbelikan 
                        tergantung pada aktivitas usaha yang dilakukan oleh penghasil emisi.

                      </p>
                      <p class="text-justify">
                       Komersialisasi dan sinergi  gas karbon monoksida (CO) treated dapat dilakukan dengan beberapa cara:
                      </p>
                      <p class="text-justify">
                      <b>Aplikasi Industri</b><br>
                      <ul style="list-style-type: decimal;">
                        <li> Bahan bakar: CO dapat digunakan sebagai bahan bakar untuk pembangkit listrik atau industri.</li>
                        <li> Sintesis kimia: CO dapat digunakan sebagai bahan baku untuk sintesis kimia, seperti produksi asam asetat atau metanol.</li>
                      </ul>
                      </p>
                        <p class="text-justify">
                      <b>Teknologi Pengolahan</b><br>
                      <ul style="list-style-type: decimal;">
                        <li> Pengolahan gas: CO dapat diolah menjadi gas yang lebih bersih dan aman untuk digunakan.</li>
                        <li> Teknologi katalis: Teknologi katalis dapat digunakan untuk meningkatkan efisiensi pengolahan CO.</li>
                      </ul>
                      </p>
                       <p class="text-justify">
                      <b>Sinergi dengan Industri Lain</b><br>
                      <ul style="list-style-type: decimal;">
                        <li> Kerjasama dengan industri kimia: CO dapat digunakan sebagai bahan baku untuk industri kimia. Ini sedang dilakukan oleh Pupuk Indonesia Utilitas dan Pupuk Kujang bekerjasama dengan PT Sintas Kurama Perdana dalam pemanfaatan sisa gas CO Dari Pabrik Pupuk Kujang
                          <br>
                          Gas buangan yang berupa gas CO (karbon monoksida) dapat dimanfaatkan kembali untuk dijual kepada industry yang membutuhkan seperti industri besi baja, industri yang membuat dry ice dan juga sebagai energi/bahan bakar untuk pengelasan.
                          <br>
                          Dalam melihat kesempatan ini PI Utilitas mengembangkan bidang usahanya yang bisa dibilang tanpa mengeluarkan investasi besar yang sebagai trader dari bahan bahan limbah industri (air, gas dan lain lain) yang masih bernilai ekonomi untuk dijual kembali kepada industry yang membutuhkan.
                        </li>
                        <li>Kerjasama dengan industri energi: CO dapat digunakan sebagai bahan bakar untuk pembangkit listrik.
                        <br>
                        Manfaat Ekonomi dari komersialisasi ini adalah menambah revenue bagi perusahaan.</li>
                      </ul>
                      </p>

                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- end of modal -->

            

            <div class="col-xl-3 col-md-6 col-12 mb-4 article-col">
              <button
                type="button"
                class="card article-card"
                data-bs-toggle="modal"
                data-bs-target="#art3"
              >
                <div class="article-media">
                  <img src="@/assets/artikel/SDG-AWARD.jpg" class="article-image" />
                  <span class="article-badge">2025</span>
                </div>
                <div class="card-body article-card-body text-start">
                  <div class="article-card-content">
                    <h5 class="article-card-title">
                       Indonesia SDG's Award (ISDA)
                    </h5>
                    <div class="card-read-more">
                      <span>{{ $t('menuBerita.readMore') }}</span>
                      <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
                    </div>
                  </div>
                </div>
              </button>
            </div>

            <!-- Modal -->

            <div class="modal fade" id="art3" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                       Indonesia SDG's Award (ISDA)
                    </h2>
                    <!-- <div class="row">
                                                <div class="col-md-6 mb-3"> -->
                    <img
                      src="@/assets/artikel/SDG-AWARD.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >2025</small
                      >
                    </p>
                    <!-- </div>
                                                <div class="col-md-6"> -->
                    <p class="text-justify">
                   Ajang Indonesia SDG’s Award merupakan acara penghargaan yang diselenggarakan oleh Corporate Forum of CSR Development bersamaan
                    dengan Indonesia CSR Award 2024. Tahun 2024 ini, tema yang diusung adalah “Towards ESG & CSV Leaderships of Business
                     Excellence”.
                    </p>
                    <p class="text-justify">
                  Indonesia SDG’s Award memberikan apresiasi kepada perusahaan-perusahaan yang dinilai telah menjalankan program-program yang
                   mendukung berbagai pilar Sustainable Development Goals (SDGs), agenda global yang dicanangkan oleh Perserikatan Bangsa-Bangsa
                    untuk meningkatkan kesejahteraan dunia. Indonesia SDG’s Award (ISDA) mempunyai tujuan integrasi pelaksanaan CSR berbasis SNI
                     ISO 26000:2013 Panduan Tanggung Jawab Sosial dan SDGs di Indonesia dalam operasional Perusahaan dan sebagai apresiasi bagi
                      institusi yang telah melaksanakan praktik CSR dan SDGs terbaik Perusahaan. 

                    </p>
                    <p class="text-justify">
                   Acara ini turut dihadiri oleh berbagai tokoh penting, termasuk Wakil Menteri Koperasi Republik Indonesia, Dr. H. Ferry Juliantono, S.E.A.K., M.Si.;
                    Koordinator Pelaksana Bidang Sumber Daya Maritim Kementerian Koordinator Bidang Pangan, Dandy Iswara; serta Staf Ahli Menteri Bidang 
                    Sosial dan Penanggulangan Kemiskinan sekaligus Kepala Sekretariat Nasional TPB/SDGs Bappenas, Dr. Pungkas Bahjuri Ali, S.TP., M.S. 
                    Kehadiran mereka menunjukkan dukungan penuh pemerintah terhadap pelaksanaan acara ini.
                      </p>
                      <p class="text-justify">
                       Ketua Umum CFCD, Ir. Thendri Supriatno, MBA menyampaikan, “Program CSR perusahaan dan program SDGs merupakan kegiatan perusahaan yang sangat strategis dalam menjamin keberlanjutan perusahaan.
                        Oleh karena itu, sangat penting untuk melaksanakan ajang apresiasi terhadap program ini. Apresiasi terhadap program ICA dan ISDA 
                        Awards akan diselenggarakan dalam rangkaian acara yang sama. Sebagai bentuk apresiasi, diberikan kepada dunia usaha, termasuk lembaga 
                        mitra perusahaan yang memiliki program atau kegiatan dalam upaya memenuhi tanggung jawab sosialnya dan berkontribusi dalam pencapaian 
                        Tujuan SDGs 2030.”
                      </p>
                      <p class="text-justify">
                    Pupuk Indonesia Utilitas berpartisipasi dalam 2 kategori SDGs yaitu SDGs 7, Energi bersih dan terjangkau & SDGs 10, Berkurangnya Kesenjangan. 
                    Program yang diikutsertakan merupakan program internal Perusahaan yaitu :
                     <ul style="lil-type-style: decimal;">
                        <li>Internal Power Supply from 20KWP Photovoltaic Power Station, dipresentasikan langsung oleh Direktur Operasi PT Pupuk Indonesia Utilitas Ibu Anis Ernani Bersama tim departemen Pengembangan PI Utilitas. Presentasi ini dinilai oleh 2 orang tim penilai yaitu E. Kurniawan Padma,S.Si, MT dan Ir. Tri Iswari, MA </li>
                        <li>Implementasi Fasilitas Non-Tunai kepada Karyawan PT Pupuk Indonesia Utilitas, dipresentasikan oleh VP SDM & Umum PT Pupuk Indonesia Utilitas Bapak Muhammad Refi Bersama tim SDM & Umum PI Utilitas.
                           Presentasi SDGs ini dinilai oleh 2 orang tim penilai yaitu Mandala Manurung, ME dan Ir. Wrantu Saraswati.</li>
                        
                      </ul>
                      </p>
                       <p class="text-justify">
                       PI Utilitas kembali mencetak prestasi membanggakan. Kali ini PI Utilitas meraih 2 penghargaan di ajang ISDG 
                       Award 2024 yang diselenggarakan oleh Corporate Forum for CSR Development. Adapun penghargaan yang diraih, yaitu;
                      </p>
                      <p class="text-justify">
                    Platinum Award untuk kontribusi terhadap SDG’s No. 7 (Energi Bersih dan Terjangkau) melalui program Instalasi PLTS di internal perusahaan.
                      </p>
                      <p class="text-justify">
                   Gold Award untuk implementasi SDG’s No. 10 (Mengurangi Ketimpangan) melalui program Fasilitas Non-Tunai untuk karyawan.
                      </p>
                      <p class="text-justify">
                        Penghargaan tersebut diterima langsung oleh Direktur Operasi PI Utilitas, Anis Ernani pada 28 November di Hotel Raffles, Jakarta.
                      </p>
                      <p class="text-justify">
                        Capaian ini menjadi bukti komitmen PI Utilitas dalam mendukung keberlanjutan, efisiensi energi, dan kesejahteraan karyawan.
                      </p>
                      <p class="text-justify">
                        Terima kasih atas dukungan seluruh PIUneers yang turut mengantarkan perusahaan menuju keberhasilan!
                        </p>
                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- end of modal -->

            <!-- modal 4 -->

            <div class="col-xl-3 col-md-6 col-12 mb-4 article-col">
              <button
                type="button"
                class="card article-card"
                data-bs-toggle="modal"
                data-bs-target="#art4"
              >
                <div class="article-media">
                  <img src="@/assets/artikel/COTRADINGOVER1.jpg" class="article-image" />
                  <span class="article-badge">2025</span>
                </div>
                <div class="card-body article-card-body text-start">
                  <div class="article-card-content">
                    <h5 class="article-card-title">
                       Komersialisasi dan sinergi perdana gas karbon monoksida (CO) treated
                    </h5>
                    <div class="card-read-more">
                      <span>{{ $t('menuBerita.readMore') }}</span>
                      <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
                    </div>
                  </div>
                </div>
              </button>
            </div>

            <!-- Modal -->

            <div class="modal fade" id="art4" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      Komersialisasi dan sinergi perdana gas karbon monoksida (CO) treated
                    </h2>
                    <!-- <div class="row">
                                                <div class="col-md-6 mb-3"> -->
                    <img
                      src="@/assets/artikel/COTRADINGOVER1.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >2025</small
                      >
                    </p>
                    <!-- </div>
                                                <div class="col-md-6"> -->
                    <p class="text-justify">
                      <b>Gambaran umum Gas Karbon monoksida.</b><br>
                  Gas karbon monoksida (CO) merupakan Gas sintentis dari yang dihasilkan dari pembakaran bahan bakar yang mengandung karbon seperti gas alam dan bensin. 
                  Gas buangan yang berupa gas CO (karbon monoksida) dapat dimanfaatkan kembali untuk dijual kepada industri yang membutuhkan seperti industri besi baja, industri yang membuat dry ice dan juga sebagai energi/ bahan bakar untuk pengelasan.
                    </p>
                    <p class="text-justify">
                      <b>Gambaran umum Gas Karbon monoksida di Indonesia.</b><br>
                Saat ini di Indonesia hanya terdapat satu Pabrik yang menjalankan proses pemurnian Gas CO yaitu PT Pupuk Kujang Cikampek melalui anak perushaannya, 
                PT Sintas Kurama Perdana (SKP). Gas CO yang dimurnikan didapatkan dari proses pembuatan amonia pada Pabrik Kujang 1A yang kemudian Gas CO tersebut dikirimkan ke unit Pabrik Pemurnian CO (PPCO), 
                setelah dimurnikan Gas CO tersebut dialirkan menuju PT SKP untuk menjadi salah satu bahan baku dalam memproduksi asam formiat. Sampai saat ini kebutuhan Gas CO oleh industri masih disupport dari luar negeri.
                 Tentunya hal ini bisa menjadi peluang bisnis baru bagi industri Gas dan Utilitas.
                    </p>
                    <p class="text-justify">
                      <b>Proses produksi (umum) gas CO</b><br>
                 Gas CO digunakan sebesar 1%-3% yang didapatkan dari secondary reformer proses pembuatan ammonia di Pabrik Kujang 1A. Kemudian gas
                  CO disalurkan menuju unit Pabrik Pemurnian CO (PPCO) untuk ditingkatkan konsentrasinya menggunakan teknologi cosorb (CO Absorbtion)
                   menjadi diatas 98% yabng kemudian disalurkan kepada PT SKP sebagai bahan baku pembuatan asam formiat.
                      </p>
                      <p class="text-justify">
                        <b>Potensi Bisnis gas CO</b><br>
                      Saat ini Pabrik Pemurnian CO (PPCO) di Indonesia hanya dimiliki oleh PT Pupuk Kujang Cikampek dengan kapasitas 12-13 Ton per hari.
                       Hal ini tentunya dapat menjadi potensi bisnis yang baik bagi industri yang membutuhkan Gas CO di area Jawa Barat sampai dengan banten.
                        Dalam hal ini peluang bisnis yang bisa didapat oleh PI Utilitas adalah dengan menjadi Trader utama Gas CO.
                      </p>
                      <p class="text-justify">
                        <b>Skema Perdagangan Kredit Karbon monoksida</b><br>
                         Dikenal juga dengan sistem baseline-and-crediting atau carbon offset. Skema ini tidak membutuhkan kuota (allowances) di awal periode, 
                       karena yang dijadikan sebagai komoditi (disebut sebagai kredit karbon) adalah hasil sertifikasi penurunan emisi karbon akibat pelaksanaan
                      </p>
                       <p class="text-justify">
                      Pada skema kredit karbon, nilai kredit didapatkan di akhir suatu periode (ex-post) yang dapat dijual dan digunakan oleh peserta
                      untuk memenuhi target penurunan emisi atau menjadikan posisi peserta menjadi carbon neutral atau zero emission.
                      </p>
                      <p class="text-justify">
                         Sedangkan untuk skema ETS, nilai kredit sudah ditentukan di awal (ex-ante), sehingga kredit baru dapat diperjualbelikan 
                        tergantung pada aktivitas usaha yang dilakukan oleh penghasil emisi.

                      </p>
                      <p class="text-justify">
                       Komersialisasi dan sinergi  gas karbon monoksida (CO) treated dapat dilakukan dengan beberapa cara:
                      </p>
                      <p class="text-justify">
                      <b>Aplikasi Industri</b><br>
                      <ul style="list-style-type: decimal;">
                        <li> Bahan bakar: CO dapat digunakan sebagai bahan bakar untuk pembangkit listrik atau industri.</li>
                        <li> Sintesis kimia: CO dapat digunakan sebagai bahan baku untuk sintesis kimia, seperti produksi asam asetat atau metanol.</li>
                      </ul>
                      </p>
                        <p class="text-justify">
                      <b>Teknologi Pengolahan</b><br>
                      <ul style="list-style-type: decimal;">
                        <li> Pengolahan gas: CO dapat diolah menjadi gas yang lebih bersih dan aman untuk digunakan.</li>
                        <li> Teknologi katalis: Teknologi katalis dapat digunakan untuk meningkatkan efisiensi pengolahan CO.</li>
                      </ul>
                      </p>
                       <p class="text-justify">
                      <b>Sinergi dengan Industri Lain</b><br>
                      <ul style="list-style-type: decimal;">
                        <li> Kerjasama dengan industri kimia: CO dapat digunakan sebagai bahan baku untuk industri kimia. Ini sedang dilakukan oleh Pupuk Indonesia Utilitas dan Pupuk Kujang bekerjasama dengan PT Sintas Kurama Perdana dalam pemanfaatan sisa gas CO Dari Pabrik Pupuk Kujang
                          <br>
                          Gas buangan yang berupa gas CO (karbon monoksida) dapat dimanfaatkan kembali untuk dijual kepada industry yang membutuhkan seperti industri besi baja, industri yang membuat dry ice dan juga sebagai energi/bahan bakar untuk pengelasan.
                          <br>
                          Dalam melihat kesempatan ini PI Utilitas mengembangkan bidang usahanya yang bisa dibilang tanpa mengeluarkan investasi besar yang sebagai trader dari bahan bahan limbah industri (air, gas dan lain lain) yang masih bernilai ekonomi untuk dijual kembali kepada industry yang membutuhkan.
                        </li>
                        <li>Kerjasama dengan industri energi: CO dapat digunakan sebagai bahan bakar untuk pembangkit listrik.
                        <br>
                        Manfaat Ekonomi dari komersialisasi ini adalah menambah revenue bagi perusahaan.</li>
                      </ul>
                      </p>

                    <!-- </div> -->
                  </div>
                </div>
              </div>
            </div>

            <!-- end modal 4 -->
            
            

    </div>
      <div class="articles-cta-wrap">
        <router-link class="articles-cta" to="/artikel">
          <span>{{ $t('menuBerita.moreArticles') }}</span>
          <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
        </router-link>
      </div>
    </section>
    <section class="press-showcase">
      <div class="section-header">
        <div>
          <h2 class="news-section-title">{{ $t('menuBerita.submenu2') }}</h2>
          <div class="section-header-line"></div>
        </div>
      </div>
    <div class="row article-grid justify-content-center">
      <div class="col-xl-3 col-md-6 col-12 mb-4 article-col">
              <button
                type="button"
                class="card article-card press-card"
                data-bs-toggle="modal"
                data-bs-target="#pers1"
              >
                <div class="article-media">
                  <img src="@/assets/siaranPers/IBEA2025.jpg" class="article-image" />
                  <span class="article-badge">2025</span>
                </div>
                <div class="card-body article-card-body press-card-body text-start">
                  <div class="press-card-content">
                    <h5 class="article-card-title">
                      Saat Energi Menjadi Kunci Ketahanan Pangan Nasional, Inilah Cara Pupuk Indonesia Utilitas
                    </h5>
                    <p class="press-card-date">2025</p>
                    <div class="card-read-more">
                      <span>{{ $t('menuBerita.readMore') }}</span>
                      <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <!-- Modal -->
            <div class="modal fade" id="pers1" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                    Saat Energi Menjadi Kunci Ketahanan Pangan Nasional, Inilah Cara Pupuk Indonesia Utilitas
                    </h2>
                    <img
                      src="@/assets/siaranPers/IBEA2025.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >2025</small
                      >
                    </p>

                    <p class="text-justify">
                        Dalam gelaran simposium Indonesia Best Electricity Award (IBEA) 2025 yang diselenggarakan di Hotel Bidakara Jakarta, Anis Ernani, Direktur Operasi PT Pupuk Indonesia Utilitas, memaparkan strategi operasional dan transformasi energi perusahaan yang bertumpu pada efisiensi, digitalisasi, dan keberlanjutan. 
                          <br>
                          <br>
                        Melalui berbagai fasilitas energi terintegrasi yang tersebar di Gresik dan Bontang, perusahaan ini berperan penting dalam menjamin kontinuitas produksi pupuk nasional, sekaligus menjaga ketahanan pangan Indonesia. 
                          <br>
                          <br>
                      <b>Energi untuk Pangan: Misi Utama Layanan Utilitas </b>
                          <br>
                          <br>
                            Pupuk Indonesia Utilitas bukan sekadar penyedia energi tetapi jantung penggerak industri pupuk nasional. "Tugas kami adalah menjamin pasokan energi baik listrik, uap, maupun nitrogen untuk mendukung proses produksi pupuk nasional. Ini adalah bagian dari kontribusi langsung kami terhadap ketahanan pangan Indonesia," ujar Anis. 
                          <br>
                        Di Gresik, perusahaan mengoperasikan pembangkit listrik tenaga gas berkapasitas 22 megawatt (MW) dan sistem heat recovery steam generator (HRSG) untuk menghasilkan uap. Sementara di Bontang, Kalimantan Timur, kapasitas operasional lebih besar dengan listrik mencapai 34 MW, produksi steam 156 ton per jam, dan nitrogen sebesar 1.500 normal meter kubik per jam. Semua fasilitas ini didesain sebagai sistem co-generation yang efisien memanfaatkan panas buang dari turbin gas untuk memproduksi uap, mengurangi limbah energi sekaligus biaya operasional. 
                          <br>
                          <br>
                        <b> Sistem Terintegrasi dan Efisiensi Tinggi </b>
                       <br>
                          Fasilitas di kedua lokasi tidak berdiri sendiri. Melalui sistem digital bernama DUMS (Digitilzed Untility Monitoring System), seluruh aktivitas operasional dipantau secara real-time. Dashboard digital ini dikembangkan oleh tim internal dan berfungsi untuk memantau performa sistem, merencanakan pemeliharaan, serta mengurangi potensi kesalahan manusia. 
                          <br>
                          <br>
                      Hasilnya? Tingkat availability dan reliability fasilitas energi Pupuk Indonesia Utilitas mencapai 99,72 persen angka yang mencerminkan hampir nihilnya gangguan suplai energi ke pabrik pupuk. 
                          <br>
                          <br>
                       <b>Pemanfaatan Energi Terbarukan</b> 
                        
                        <br>
                       Sebagai bentuk komitmen terhadap transisi energi bersih, perusahaan telah mengoperasikan pembangkit listrik tenaga surya (PLTS) dengan kapasitas 3,4 MWp, yang menyuplai kebutuhan energi non-produksi di lingkungan operasional. Kontribusi energi terbarukan ini setara dengan pengurangan emisi karbon hingga 5.000 ton per tahun.
                        <br>
                        <br>
                        Selain itu, budaya inovasi juga menjadi bagian tak terpisahkan dari strategi perusahaan. Tim internal terus didorong untuk menciptakan solusi-solusi baru, baik dari sisi teknis maupun efisiensi bisnis. "Kami percaya, inovasi adalah pondasi untuk bertahan dan tumbuh di tengah dinamika kebutuhan industri pupuk yang terus berubah," jelas Anis. 
                        <br>
                        <br>
                       Dalam paparannya, Anis menegaskan bahwa perusahaan tidak hanya mengandalkan operasional konvensional, tetapi juga mengembangkan sistem pemeliharaan berbasis <i>predictive maintenance</i>, menerapkan TPM <i>(Total Productive Maintenance)</i>, serta memperkuat kompetensi SDM melalui sertifikasi dan pelatihan berkelanjutan. 
                      <br>
                      <br>
                      Perjalanan Pupuk Indonesia Utilitas mencerminkan bagaimana sebuah unit bisnis utilitas tidak hanya berperan sebagai penyokong industri, tetapi juga sebagai motor penggerak transformasi energi nasional. Di tengah tantangan perubahan kebutuhan pabrik pupuk dan tuntutan efisiensi energi, pendekatan integratif dan digital yang mereka terapkan dapat menjadi model bagi perusahaan utilitas lainnya di Indonesia. 
                        <br>
                        <br>
                        “Visi kami adalah menjadi penyedia layanan utilitas industri berbasis energi yang andal, efisien, dan berkelanjutan. Karena bagi kami, menyediakan energi berarti menjaga masa depan pangan negeri,” tutup Anis.
                        <br>
                       </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-12 mb-4 article-col">
              <button
                type="button"
                class="card article-card press-card"
                data-bs-toggle="modal"
                data-bs-target="#pers2"
              >
                <div class="article-media">
                  <img src="@/assets/siaranPers/TREEVOLUTIONCOVER.jpg" class="article-image" />
                  <span class="article-badge">2025</span>
                </div>
                <div class="card-body article-card-body press-card-body text-start">
                  <div class="press-card-content">
                    <h5 class="article-card-title">
                      Peringati Hari Bumi, PT Pupuk Indonesia Utilitas Berkolaborasi dengan Dinas Lingkungan Hidup serta CPNS setempat Tanam 500 Pohon di Gresik, Jawa Timur.
                    </h5>
                    <p class="press-card-date">25 April 2025</p>
                    <div class="card-read-more">
                      <span>{{ $t('menuBerita.readMore') }}</span>
                      <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <!-- Modal -->
            <div class="modal fade" id="pers2" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                     Peringati Hari Bumi, PT Pupuk Indonesia Utilitas Berkolaborasi dengan Dinas Lingkungan Hidup serta CPNS setempat Tanam 500 Pohon di Gresik, Jawa Timur.
                    </h2>
                    <img
                      src="@/assets/siaranPers/TREEVOLUTIONCOVER.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy">25 April 2025</small>
                    </p>

                    <p class="text-justify">
                          <b>GRESIK</b> Dalam upaya mendukung pelestarian lingkungan dan peningkatan kualitas udara serta dalam rangka memperingati Hari Bumi yang jatuh setiap 22 April, Bupati Kabupaten Gresik, yang diwakili oleh Wakil Bupati Gresik dr. Asluchul Alif, M.Kes memimpin penanaman pohon program Treevolution PT Pupuk Indonesia Utilitas (PI Utilitas) dengan melakukan penanaman total sejumlah 500 pohon di hutan kota Gejos, Kabupaten Gresik, Provinsi Jawa Timur, Jumat, 25 April 2025.
                          <br>
                          <br>
                         Direktur Utama (Dirut) PI Utilitas, Mochamad Safiie, mengemukakan jika pohon yang ditanam oleh PI Utilitas terdiri dari 250 pohon jenis sawo dan jambu.
                          <br>
                          <br>
                       “Serta 250 pohon lainnya dengan berbagai varietas atas partisipasi para CPNS Kabupaten Gresik,” katanya.
                          <br>
                          <br>
                       Mochamad Safiie mengutarakan jika kegiatan penanaman pohon bersama merupakan realisasi program perseroan bertajuk  “Treevolution PT Pupuk Indonesia Utilitas”. Dalam merealisasikan program perusahaan yang dipimpinnya, PI Utilitas berkolaborasi dengan Dinas Lingkungan Hidup Kabupaten Gresik.
                          <br>
                          Selain memperingati Hari Bumi, program perseroan juga direalisasikan dalam rangka mendukung program 100 hari Nawakarsa Bupati dan Wakil Bupati Gresik 2025-2030. 
                          <br>
                          <br>
                        “Perjuangan untuk melindungi lingkungan tidak bisa dilakukan sendiri,” ujarnya.
                          <br>
                          <br>
                       Pada kesempatan yang sama, Wakil Bupati Gresik, Asluchul Alif, mengungkapkan jika kolaborasi dengan PI Utilitas adalah cara terbaik untuk mencegah krisis iklim. Penanaman pohon sawo dan jambu air menurutnya adalah upaya membangun ekosistem penyerap emisi gas rumah kaca. Fandi menekankan pohon tidak semata-mata berfungsi menyerap emisi.
                          <br>
                          <br>
                        “Namun juga mengubahnya menjadi zat-zat yang berguna bagi makhluk hidup lain, katanya.    
                        <br>
                        <br>
                        Acara dimulai sejak pukul 08.00 Waktu Indonesia Barat (WIB) dan berakhir menjelang ibadah Salat Jumat. Diikuti oleh Wakil Bupati Gresik, Ketua DPRD Gresik, jajaran Forum Kordinasi Pimpinan Daerah (Forkopimda), Komisaris dan Direksi PT Pupuk Indonesia Utilitas, serta Para Calon Pegawai Negeri Sipil (CPNS) Kabupaten Gresik.
                        <br>
                        <br>
                        <b>Treevolution</b>
                        <br>
                        Merupakan gerakan program revolusi hijau agar menanam lebih banyak pohon untuk keberlanjutan lingkungan dan mendukung dekarbonisasi. Kegiatan penanaman pohon pada hari ini ini bukan sekadar seremoni yang bersifat simbolik, namun merupakan tanggung jawab dan aksi nyata korporasi.
                        <br>
                        <br>
                        Treevolution yang sudah ditetapkan menjadi program perusahaan akan terus diperluas jangkauan pelaksanaan penanaman pohonnya dengan lebih banyak lagi, PI Utilitas selalu berupaya untuk meningkatkan kesadaran menjaga dan melestarikan lingkungan hidup. Perseroan menyadari dampak perubahan iklim pada saat ini semakin mengkhawatirkan. Jadi tindakan kecil seperti menanam pohon bisa membawa dampak yang besar bagi planet bumi.
                        
                       </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-12 mb-4 article-col">
              <button
                type="button"
                class="card article-card press-card"
                data-bs-toggle="modal"
                data-bs-target="#pers3"
              >
                <div class="article-media">
                  <img src="@/assets/siaranPers/TOPGRC2024.jpg" class="article-image" />
                  <span class="article-badge">2024</span>
                </div>
                <div class="card-body article-card-body press-card-body text-start">
                  <div class="press-card-content">
                    <h5 class="article-card-title">
                     PI Utilitas sabet 2 penghargaan di TOP GRC Awards 2024
                    </h5>
                    <p class="press-card-date">11 September 2024</p>
                    <div class="card-read-more">
                      <span>{{ $t('menuBerita.readMore') }}</span>
                      <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <!-- Modal -->
            <div class="modal fade" id="pers3" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      PI Utilitas sabet 2 penghargaan di TOP GRC Awards 2024
                    </h2>
                    <img
                      src="@/assets/siaranPers/TOPGRC2024.jpg"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >11 September 2024</small
                      >
                    </p>

                    <p class="text-justify">
                         <b>Tingkatkan kinerja bisnis dan berkelanjutan melalui pendekatan GRC, ESG dan SDGs</b>
                          <br>
                          <br>
                         PT Pupuk Indonesia Utilitas (PI Utiltias) berhasil menyabet dua penghargaan sekaligus dalam ajang Top GRC Awards yang digelar oleh Majalah TopBusiness, Rabu, 11 September 2024 di Hotel Raffles Jakarta dengan mengusuh tema “Leadership for Sustainable Impact : GRC, ESG, and SD’s)
                          <br>
                          <br>
                          "Ini adalah hasil dari kerja keras PI Utilitas dalam memberikan pelayanan sesuai dengan aturan yang berlaku dan menjadi motivasi bagi semua karyawan dan jajaran direksi untuk terus melakukan inovasi dan prestasi," kata Direktur Utama PT Pupuk Indonesia Utilitas Mochamad Safiie
                          <br>
                          <br>
                         Penghargaan pertama yang diraih adalah “TOP GRC Awards 2024 # 5 Stars“yang merupakan bentuk penghargaan apresiasi untuk PI Utilitas  yang telah menerapkan prinsip Governance, Risk, and Compliance secara menyeluruh di seluruh kegiatan operasional perusahaan. 
                          <br>
                          <br>
                          Penghargaan kedua diraih oleh Direktur Utama PT Pupuk Indonesia Utilitas Mochamad Safiie sebagai “The Most Committed GRC Leader” dinilai memiliki komitmen tinggi dalam mendukung sistem infrastruktur dan keberhasilan dalam menjaga tingkat kinerja bisnis dan juga berkelanjutan melalui pendekatan GRC, ESG, and SD’s.”
                          <br>
                          <br>
                         Antonius Alijoyo selaku dewan juri Top GRC Awards mengatakan penghargaan diberikan kepada PT Pupuk Indonesia Utilitas karena beberapa penilaian diantaranya kelengkapan sistem dan infrastruktur penunjang GRC di dalam perusahaan peserta yang sudah semakin lengkap dan meningkat. 
                          <br>
                          <br>
                         <b>Berikut beberapa temuan penting dalam jangka waktu tersebut:</b>
                          <br>
                          <br>
                         Pertama Efektivitas implementasi GRC akan lebih mudah tercapai jika komponen Governance, komponen Risk Management, dan komponen Compliance Management, terintegrasi dan tidak bersifat Silo-Silo.
                          <br>
                          <br>
                         Kedua, GRC, ESG (Environment Social Governance), dan SDGs (Sustainable, Development, Goals) yang mulai menjadi tren yang mengakibatkan para investor semakin peduli dengan aspek sosial dan lingkungan demi menjaga keberlanjutan iklim bisnis sehingga GRC, ESG, dan SDGs perlu dikolaborasikan dan diintegrasikan dalam manajemen bisnis agar perusahaan terus memiliki ketahanan dan kelincahan di bisnis yang akan datang. 
                          <br>
                          <br>
                          Ketiga, peran leader atau pemimpin merupakan peran yang penting dalam menjaga keberlanjutan dan juga keberhasilan GRC suatu perusahaan. 
                          <br>
                          <br>
                         Keempat, pengembangan teknologi TI/digital untuk mendukung sistem dan juga implementasi GRC di perusahaan sangat bermanfaat untuk meningkatkan efektivitas implementasi GRC.
                       </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-xl-3 col-md-6 col-12 mb-4 article-col">
              <button
                type="button"
                class="card article-card press-card"
                data-bs-toggle="modal"
                data-bs-target="#pers4"
              >
                <div class="article-media">
                  <img src="@/assets/siaranPers/PEFINDO.png" class="article-image" />
                  <span class="article-badge">2024</span>
                </div>
                <div class="card-body article-card-body press-card-body text-start">
                  <div class="press-card-content">
                    <h5 class="article-card-title">
                      Pupuk Indonesia Utilitas diganjar peringkat idAA- oleh Pefindo
                    </h5>
                    <p class="press-card-date">21 Juni 2024</p>
                    <div class="card-read-more">
                      <span>{{ $t('menuBerita.readMore') }}</span>
                      <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
                    </div>
                  </div>
                </div>
              </button>
            </div>
            <!-- Modal -->
            <div class="modal fade" id="pers4" tabindex="-1" aria-hidden="true">
              <div class="modal-dialog modal-xl modal-fullscreen-sm-down">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                    ></button>
                  </div>
                  <div class="container modal-body p-3">
                    <h2 class="modal-title">
                      Pupuk Indonesia Utilitas diganjar peringkat idAA- oleh Pefindo
                    </h2>
                    <img
                      src="@/assets/siaranPers/PEFINDO.png"
                      class="img-fluid p-3"
                    />
                    <p class="card-text text-start">
                      <small class="text-body-secondaryy"
                        >21 Juni 2024</small
                      >
                    </p>

                    <p class="text-justify">
                      PT Pemeringkat Efek Indonesia (Pefindo) memberikan peringkat idAA- dengan prospek stabil terhadap PT Pupuk Indonesia Utilitas (PIU).
                      <br>
                      <br>
                      “Peringkat perusahaan mencerminkan kuatnya kemungkinan dukungan dari PT Pupuk Indonesia (Persero) (PIHC, peringkat idAAA dan prospek stabil) selaku pemegang saham, pengelolaan kegiatan usaha yang baik, perlindungan arus kas yang kuat dan risiko off-taker yang minimal,” tulis Pefindo dalam keterangan resmi dikutip, Jumat, 21 Juni 2024.
                      <br>
                      <br>
                      Peringkat dibatasi oleh posisi pasar yang moderat. Peringkat dapat dinaikkan jika PIUT memperkuat posisinya dalam industri, sekaligus meningkatkan struktur permodalan secara berkelanjutan. Namun, peringkat dapat diturunkan jika kami melihat penurunan dukungan yang signifikan dari pemegang saham Perusahaan.
                      <br>
                      <br>
                      Baca juga: Obligasi Rp2,09 Triliun Milik Pupuk Indonesia Akan Segera Jatuh Tempo
                      <br>
                      <br>
                      Peringkat juga dapat diturunkan jika arus kas yang dihasilkan dari kegiatan usaha Perusahaan secara signifikan jauh di bawah proyeksi, atau jika utang Perusahaan melebihi proyeksi tanpa disertai dengan posisi bisnis yang lebih kuat. “Perubahan peringkat terhadap PIHC juga dapat memicu perubahan peringkat yang serupa terhadap PIUT.”
                      <br>
                      <br>
                      PIU didirikan pada tahun 2014 dan bergerak di sektor energi dan utilitas, saat ini melayani beberapa anak perusahaan di dalam PIHC, yaitu PT Petrokimia Gresik (PTGR) dan PT Pupuk Kaltim (PPKT).
                      <br>
                      <br>
                      PIUT memiliki satu unit Gas Turbin Generator (GTG) dengan kapasitas 23 megawatt (MW) dan satu unit Heat Recovery Steam Generator (HRSG) dengan kapasitas 150 ton per jam (Tph), menyediakan produk uap ke PTGR.
                      <br>
                      <br>
                      Pada 31 Desember 2023, pemegang saham Perusahaan adalah PIHC (60%), PPKT (10%), PTGR (10%), PT Pupuk Sriwidjaya (7%), dan entitas dalam grup lainnya dengan kepemilikan di bawah 5% (13%).
                    </p>
                  </div>
                </div>
              </div>
            </div>
    </div>
      <div class="articles-cta-wrap">
        <router-link class="articles-cta" to="/pers">
          <span>{{ $t('menuBerita.morePress') }}</span>
          <img src="../assets/Arrow-right-resized.png" alt="Arrow right" />
        </router-link>
      </div>
    </section>
  </div>
</div>
</template>

<script>
export default {
  name: "NewsCarousal",
};
</script>

<style scoped>
.news-showcase {
  background:
    radial-gradient(circle at top left, rgba(12, 111, 184, 0.08), transparent 30%),
    linear-gradient(180deg, #edf4f9 0%, #f7fbfe 100%);
}

.news-shell {
  padding-top: clamp(3.5rem, 5vw, 4.5rem);
  padding-bottom: clamp(4rem, 6vw, 5.5rem);
}

.articles-showcase {
  margin-bottom: clamp(3rem, 5vw, 4.5rem);
}

.press-showcase {
  margin-top: 0.5rem;
}

.section-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.75rem;
}

.news-section-title {
  margin: 0;
  color: #084e8b;
  font-size: clamp(2.35rem, 4vw, 4rem);
  font-weight: 800;
  line-height: 0.94;
}

.section-header-line {
  width: 118px;
  height: 6px;
  margin-top: 0.95rem;
  border-radius: 999px;
  background: linear-gradient(90deg, #f15a24, #0f6fb7 62%, #3ba574);
}

.article-grid {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 1.5rem;
}

.article-col {
  display: flex;
}

.article-card {
  width: 100%;
  height: 100%;
  overflow: hidden;
  border: 1px solid rgba(13, 93, 151, 0.12);
  border-radius: 28px;
  background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
  box-shadow: 0 20px 42px rgba(8, 78, 139, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

.article-card:hover {
  transform: translateY(-10px);
  border-color: rgba(13, 111, 183, 0.25);
  box-shadow: 0 28px 56px rgba(8, 78, 139, 0.16);
}

.article-media {
  position: relative;
  overflow: hidden;
  padding: 16px 16px 0;
}

.article-media::after {
  content: "";
  position: absolute;
  inset: 16px 16px 0;
  border-radius: 22px;
  background: linear-gradient(180deg, rgba(8, 78, 139, 0.05), rgba(8, 18, 40, 0.4));
  pointer-events: none;
}

.article-image {
  width: 100%;
  height: 188px;
  border-radius: 22px;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.article-card:hover .article-image {
  transform: scale(1.06);
}

.article-badge {
  position: absolute;
  top: 28px;
  left: 28px;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  padding: 0.42rem 0.8rem;
  border-radius: 999px;
  background: rgba(8, 18, 40, 0.68);
  color: #ffffff;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  backdrop-filter: blur(6px);
}

.article-card-body {
  display: flex;
  align-items: stretch;
  min-height: 178px;
  padding: 1.25rem 1.3rem 1.45rem;
}

.article-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  gap: 0.95rem;
}

.article-card-title {
  margin: 0;
  color: #0a4f8b;
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.18;
}

.press-card-body {
  align-items: stretch;
  min-height: 192px;
}

.press-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  gap: 0.7rem;
}

.press-card .article-card-title {
  min-height: 7.9rem;
}

.press-card-date {
  margin: 0;
  color: #7d899a;
  font-size: 0.98rem;
  font-weight: 500;
  line-height: 1.35;
}

.card-read-more {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin-top: auto;
  padding-top: 0.95rem;
  border-top: 1px solid rgba(10, 79, 139, 0.12);
  color: #0f6fb7;
  font-size: 0.88rem;
  font-weight: 700;
  line-height: 1;
}

.card-read-more img {
  width: 18px;
  height: auto;
  opacity: 0.9;
  filter: invert(26%) sepia(82%) saturate(1281%) hue-rotate(183deg) brightness(93%) contrast(91%);
  transition: transform 0.25s ease;
}

.article-card:hover .card-read-more img {
  transform: translateX(3px);
}

.articles-cta-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.55rem;
}

.articles-cta {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  padding: 0.7rem 0.95rem 0.7rem 1rem;
  border-radius: 14px;
  background: linear-gradient(135deg, #0c589a, #0f6fb7);
  box-shadow: 0 14px 28px rgba(8, 78, 139, 0.16);
  color: #ffffff;
  font-size: 0.88rem;
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.articles-cta:hover {
  transform: translateY(-3px);
  box-shadow: 0 18px 32px rgba(8, 78, 139, 0.22);
  color: #ffffff;
}

.articles-cta img {
  width: 30px;
  height: auto;
  filter: brightness(0) invert(1);
}

.card-fixed {
  width: 100%; /* Adjust as needed */
  height: 350px; /* Adjust as needed */
  box-shadow: 0 4px 8px rgba(0, 183, 255, 0.25);
  transition: transform 0.3s ease;
  border-radius: 10px;
}
/* .modal-content{
  border-radius: 0;
} */
.card-fixed:hover {
  box-shadow: 0 8px 16px rgba(0, 195, 255, 0.4); /* Adjust as needed */
  transform: scale(1.05);
}

.text-body-secondaryy {
  color: grey;
  font-style: italic;
  font-weight: 300;
}

.card-title {
  font-weight: 600;
  color: #084e8b;
  font-size: 16px;
  margin-top:20px;
}

.card-more {
  height: 100%;
  width: 100%;
  box-shadow: 0 4px 8px rgba(0, 47, 255, 0.25);
  transition: transform 0.3s ease;
  border-radius: 10px;
}

.card-more:hover {
  box-shadow: 0 8px 16px rgba(0, 102, 255, 0.4); /* Adjust as needed */
  transform: scale(1.05);
}
.img-fixed {
  width: 100%; /* Adjust as needed */
  height: 150px; /* Adjust as needed */
  object-fit: cover;
}
.modal-title {
  font-weight: 700;
  color: #084e8b;
  font-style: italic;
  text-align: center;
  /* text-shadow: 2px 1px #00b7ff; */
}

.head-modal {
  font-weight: 600;
  color: #f15a24;
  font-size: x-large;
}
p {
  text-align: justify;
}

@media (max-width: 767px) {
  .news-shell {
    padding-top: 3rem;
    padding-bottom: 3.75rem;
  }

  .section-header {
    margin-bottom: 1.25rem;
  }

  .article-media {
    padding: 14px 14px 0;
  }

  .article-media::after {
    inset: 14px 14px 0;
  }

  .article-image {
    height: 210px;
    border-radius: 20px;
  }

  .article-card-body {
    min-height: auto;
    padding: 1.05rem 1.05rem 1.25rem;
  }

  .article-card-title {
    font-size: 1.02rem;
  }

  .card-read-more {
    font-size: 0.84rem;
  }

  .press-card-body {
    min-height: auto;
  }

  .press-card .article-card-title {
    min-height: auto;
  }

  .press-card-date {
    font-size: 0.92rem;
  }

  .articles-cta {
    width: auto;
    justify-content: center;
    padding: 0.68rem 0.9rem 0.68rem 0.95rem;
    font-size: 0.84rem;
  }
}
</style>
